import Container from "../../../../components/container";

export default function OccasionCollectionsTableSkeleton() {
  return (
    <Container className="max-w-xl text-left">
      <table className="min-w-full text-gray-900 text-left">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th scope="col" className="px-6 py-3">Name</th>
            <th scope="col" className="px-6 py-3"><span className="sr-only">Edit</span></th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {[...Array(5)].map((_, index) => (
            <tr key={index} className="w-full border-b py-3 text-sm last-of-type:border-none [&:first-child>td:first-child]:rounded-tl-lg [&:first-child>td:last-child]:rounded-tr-lg [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg">
              <td className="whitespace-nowrap px-6 py-3">
                <div className="h-6 w-32 rounded bg-gray-100 animate-pulse"></div>
              </td>
              <td className="whitespace-nowrap px-6 py-3">
                <div className="flex justify-end gap-2">
                  <div className="h-8 w-8 rounded bg-gray-100 animate-pulse"></div>
                  <div className="h-8 w-8 rounded bg-gray-100 animate-pulse"></div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}
